import * as React from 'react';

function Tooltip(props) {
	return (
		<svg
			aria-label={`tooltip icon`}
			width={'23'}
			height={'23'}
			viewBox={'0 0 23 23'}
			fill={'none'}
			xmlns={'http://www.w3.org/2000/svg'}
			{...props}
		>
			<title>tooltip icon</title>
			<circle cx={'11.5'} cy={'11.5'} r={'10.5'} stroke={'#1F1F1F'} />
			<path d={'M10.9464 6.42001V8.33801H12.7944V6.42001H10.9464ZM11.0024 16.5H12.7244V9.44401H11.0024V16.5Z'} fill={'#1F1F1F'} />
		</svg>
	);
}

export default Tooltip;
